import './index.css';
import ViewerTableSkeleton from './table';

export default function ViewerSkeleton() {
  return (
    <div className='vp-skeleton'>
      <div className='vp-skeleton-header' />
      <div className='vp-skeleton-date shimmer' />
      <div className='vp-skeleton-title shimmer' />
      <div className='vp-skeleton-status shimmer' />

      <div className='vp-skeleton-box shimmer' />

      <ViewerTableSkeleton />
    </div>
  );
}
